import React, { useContext, useRef, useState } from "react";
import { userOnboardingContext } from "../../../states/context/userOnboardingContext";
import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  TextField,
} from "@mui/material";
import { styled } from '@mui/material/styles';
import addIcon from "../../../assets/images/userOnboarding/add-circle.svg";
import minusIcon from "../../../assets/images/userOnboarding/minus-cirlce.svg";
import { useNavigate } from "react-router-dom";
import rightArrow from "../../../assets/images/new-arrow-left.svg"
import leftArrow from "../../../assets/images/new-arrow-left-colored.svg"

const CheckListContainer = styled('div')(({ theme }) => ({
  marginTop: "32px",
  "& .MuiTypography-body1": {
    fontFamily: "Figtree",
  },
}));

const LabelTopAligned = styled(FormControlLabel)(({ theme }) => ({
  alignItems: "flex-start",
  marginBottom: "16px",
  fontWeight: 400,
  '& span.MuiTypography-root.MuiFormControlLabel-label.MuiTypography-body1': {
    lineHeight: 'normal',
    color: '#171717',
    display: "flex",
    alignItems: "center",
  },
}));

const AddBtn = styled(Button)(({ theme }) => ({
  paddingLeft: 0,
  color: "#6933FF",
  fontWeight: 600,
  textTransform: "none",
  fontSize: '16px',
}));

const MinusIcon = styled('img')(({ theme }) => ({
  verticalAlign: "-webkit-baseline-middle",
}));

const NewRowFormControl = styled(FormControlLabel)(({ theme }) => ({
  "& .MuiTypography-root.MuiFormControlLabel-label.MuiTypography-body1": {
    display: "flex",
    width: "100%",
  },
  "& .MuiFormControl-root.MuiTextField-root": {
    width: "100%",
  },
  "& .MuiInput-underline:before": {
    borderBottom: "none", // Remove the default underline
  },
  "& .MuiInput-underline:after": {
    borderBottom: "none", // Remove the focused underline
  },
  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
    borderBottom: "none", // Remove the hovered underline
  },
}));

const ButtonContainer = styled('div')(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  marginTop: "40px",
}));

const NextButton = styled(Button)(({ theme }) => ({
  height: "48px",
  borderRadius: "8px",
  backgroundColor: "#6933FF",
  border: "none",
  outline: "none",
  color: "white",
  fontSize: "16px",
  fontWeight: "600",
  textTransform: "none",
  "& span": {
    fontFamily: "Figtree",
  },
  "&:hover": {
    backgroundColor: "#5a2fdd",
  },
  "&:disabled": {
    backgroundColor: "#E8E8E8",
    color: "#FFFFFF",
  },
}));

const BackButton = styled(Button)(({ theme }) => ({
  color: "#6933FF",
  fontSize: "16px",
  fontWeight: "600",
  textTransform: "none",
}));

const InputField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-input": {
    fontFamily: "Figtree",
    color: '#171717',
  },
}));

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  "&.Mui-checked": {
    color: '#6933FF',
  },
}));

const ObjectivesChallengesCheckList = ({ itemList, addBtnText }) => {
  const navigate = useNavigate();
  const { user, setUser } = useContext(userOnboardingContext);
  const { challengesExtraFields, objectivesExtraFields, objectives, challenges } = user;
  const [newRows, setNewRows] = useState([]);
  const inputRefs = useRef([]);

  const handleCheckboxChange = (item, event, index) => {
    const { checked } = event.target;
    const value = itemList[index].text;

    const newArray = [...itemList];
    newArray[index] = { checked: checked, text: value, type: item?.type };

    if (addBtnText === "challenge") {
      //   setChallenge(newArray);
      setUser({ ...user, challenges: newArray });
      return;
    }
    setUser({ ...user, objectives: newArray });
    // setObjective(newArray);
    return;
  };

  const handleNewRowCheckboxChange = (event, rowIndex) => {
    const { checked } = event.target;

    setNewRows((prevRows) =>
      prevRows.map((row, index) =>
        index === rowIndex ? { ...row, checked } : row
      )
    );
  };

  const handleInputChange = (event, rowIndex) => {
    const value = event.target.value;

    setNewRows((prevRows) =>
      prevRows.map((row, index) =>
        index === rowIndex ? { ...row, text: value } : row
      )
    );
  };

  const handleAddButtonClick = () => {
    // Create a new row with default values
    const newRow = { type: "custom", checked: true, text: "" };
    setNewRows((prevRows) => [...prevRows, newRow]);

    // Focus on the new input field
    setTimeout(() => {
      const newRowIndex = newRows.length;
      if (inputRefs.current[newRowIndex]) {
        inputRefs.current[newRowIndex].focus();
      }
    }, 0);

    if (addBtnText === "challenge") {
      setUser({ ...user, challengesExtraFields: challengesExtraFields + 1 });
      return;
    }
    setUser({ ...user, objectivesExtraFields: objectivesExtraFields + 1 });
    return;
  };
  const handleRemoveCustomRowFromList = (rowIndex) => {
    if (addBtnText === "challenge") {
      const filteredRow = challenges.filter((_, index) => index !== rowIndex)
      setUser({ ...user, challenges: filteredRow, challengesExtraFields: challengesExtraFields - 1 });
      return;
    }
    const filteredRow = objectives.filter((_, index) => index !== rowIndex)
    setUser({ ...user, objectives: filteredRow, objectivesExtraFields: objectivesExtraFields - 1 });
    return;
  }

  const handleRemoveRow = (rowIndex) => {
    setNewRows((prevRows) => prevRows.filter((_, index) => index !== rowIndex));
    if (addBtnText === "challenge") {
      setUser({ ...user, challengesExtraFields: challengesExtraFields - 1 });
      return;
    }
    setUser({ ...user, objectivesExtraFields: objectivesExtraFields - 1 });
    return;
  };

  const handleNext = () => {
    let newArray;
    newArray = [...itemList];
    newRows?.map((item, index) => {
      newArray[itemList.length + index] = item;
    });
    if (addBtnText === "challenge") {
      //   setChallenge(newArray);
      setUser({...user, challenges: newArray})
      navigate("/onboarding/build-agent");
      return;
    }

    // setObjective(newArray);
    setUser({ ...user, objectives: newArray });
    navigate("/onboarding/challenge");
    return;
  };
  const handleBack = () => {
    let newArray;
    newArray = [...itemList];
    newRows?.map((item, index) => {
      newArray[itemList.length + index] = item;
    });
    if (addBtnText === "challenge") {
      //   setChallenge(newArray);
      setUser({ ...user, challenges: newArray });
      navigate("/onboarding/objective");
      return;
    }
    // setObjective(newArray);
    setUser({ ...user, objectives: newArray });
    navigate("/onboarding/role");
    return;
  };

  return (
    <>
      <CheckListContainer>
        <FormGroup>
          {itemList.map((item, index) => (
            <LabelTopAligned
              key={index}
              control={
                <StyledCheckbox
                  checked={item.checked}
                  onChange={(event) => handleCheckboxChange(item, event, index)}
                  style={{ paddingTop: "0px" }}
                  color="default"
                />
              }
              // label={item.text}
              label={
                <>
                  {item.type && item.type === "custom" && (
                    <MinusIcon
                      src={minusIcon}
                      alt="removeIcon"
                      style={{ marginRight: "2px" }}
                      onClick={() => handleRemoveCustomRowFromList(index)}
                    />
                  )}
                  {item.text}
                </>
              }
            />
          ))}

          {/* Render new rows dynamically */}
          {newRows.map((row, index) => (
            <NewRowFormControl
              key={index}
              control={
                <StyledCheckbox
                  checked={row.checked}
                  onChange={(event) => handleNewRowCheckboxChange(event, index)}
                />
              }
              style={{ width: "100%" }}
              label={
                <>
                  <MinusIcon
                    src={minusIcon}
                    alt="removeIcon"
                    style={{ marginRight: "2px" }}
                    onClick={() => handleRemoveRow(index)}
                  />
                  <InputField
                    value={row.text}
                    onChange={(event) => handleInputChange(event, index)}
                    placeholder={`Type your ${addBtnText}`}
                    variant="standard"
                    inputRef={(el) => (inputRefs.current[index] = el)}
                  />
                </>
              }
            />
          ))}

          {/* Always visible "Add" button at the bottom */}
          {((addBtnText === "challenge" && challengesExtraFields < 5) || (addBtnText === "objective" && objectivesExtraFields < 5)) && <FormControlLabel
            control={<Checkbox checked={false} color="primary" disabled />}
            label={
              <AddBtn
                onClick={handleAddButtonClick}
                disabled={
                  addBtnText === "challenge"
                    ? challengesExtraFields === 5
                    : objectivesExtraFields === 5
                }
              >
                <img
                  src={addIcon}
                  alt="addIcon"
                  style={{ marginRight: "2px" }}
                />
                Add {addBtnText}
              </AddBtn>
            }
          />}
        </FormGroup>
      </CheckListContainer>
      <ButtonContainer>
        <BackButton onClick={handleBack}>
          <img src={leftArrow} alt="leftArrow" style={{ marginRight: "4px" }} />
          Back
        </BackButton>
        <NextButton
          onClick={handleNext}
          disabled={
            !itemList.some((item) => item.checked) &&
            !newRows.some((row) => row.text !== "" && row.checked)
          }
          style={
            addBtnText === "challenge" ? { width: "168px" } : { width: "120px" }
          }
        >
          {addBtnText === "challenge" ? "Get started" : "Next"}
          <img
            src={rightArrow}
            alt="rightArrow"
            style={{ marginLeft: "4px" }}
          />
        </NextButton>
      </ButtonContainer>
    </>
  );
};

export default ObjectivesChallengesCheckList;
